var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search',{attrs:{"handleOptions":_vm.handleConsumptionSearch,"getData":_vm.getConsumptionData}}),_c('List',{attrs:{"handleOptions":_vm.handleConsumptionSearch,"page":_vm.consumptionPage,"getData":_vm.getConsumptionData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }